module.exports = __webpack_public_path__ + "img/operatin_cost-green.dafa624d.png";